export enum RoutesEnum {
  Accounts = 'accounts/#',
  AccountDetails = 'account-details',
  AccountSummary = 'account-summary',
  Root = 'accountsv3',
}
